import { Component } from '@angular/core';

@Component({
    templateUrl: '../../../../../../assets/svg/search.svg',
})
export class SearchComponent { }
